module.exports = __webpack_public_path__ + "static/img/oyin.10704e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/oyin.jpg
// module id = LwRa
// module chunks = 0